import getFilters from './getFilters';

export default {
  getFilters,
};



// WEBPACK FOOTER //
// ./src/api/filters/actions/index.js